import CutscenePlayer from './CutscenePlayer';

export default class OverlayCount extends Phaser.Group {
  constructor(game, characterId, withCircle) {
    super(game);

    this.bg = this.game.make.image(0, 0, 'bg_location_' + this.game.controller.location);
    this.addChild(this.bg);

    if (this.game.controller.isFirstLevel()) {
      withCircle = true;
      this.sceneData = this.game.controller.cutscenes.getScene('cutscene_01');
    } else {
      this.sceneData = this.game.controller.cutscenes.getScene('cutscene_counting_' + characterId);
    }

    //
    this.onCountEnd = new Phaser.Signal();

    //
    this.cutscene = new CutscenePlayer(this.game, this.sceneData.id);
    this.addChild(this.cutscene);
    this.cutscene.x = this.game.defaultWidth / 2;
    this.cutscene.y = this.game.defaultHeight / 2;

    if (!this.game.controller.isFirstLevel()) {
      this.cutscene.setAudioId(characterId);
    }

    this.cutscene.onAnimComplete.addOnce(this.handleAnimComplete, this);

    if (!withCircle) {
      this.cutscene.playAnim(this.cutscene.data.anims[1]);
    }

    // lock content under
    this.bg.inputEnabled = true;
  }

  handleAnimComplete() {
    this.onCountEnd.dispatch();
  }

  setIcon() {
    // this.icon = this.cutscene.getIcon();
    // this.icon.x += this.cutscene.x;
    // this.icon.y += this.cutscene.y;
    // this.addChild(this.icon);

    this.cutscene.destroy();
    this.cutscene = null;

    // scale down icon
    // const root = this.icon.skeleton.getRootBone();
    // this.game.add.tween(root).to({ scaleX: 0.4, scaleY: 0.4 }, 500, null, true);

    // move icon up
    // const x1 = (this.game.defaultWidth - this.game.width) / 2 + 360;
    // this.game.add.tween(this.icon).to({ x: x1, y: 40 }, 500, null, true);

    // fade out background
    this.game.add
      .tween(this.bg)
      .to({ alpha: 0 }, 300, null, true)
      .onComplete.add(this.removeBackground, this);
  }

  removeBackground() {
    this.bg.destroy();
    this.bg = null;
  }

  positionElements() {
    if (this.icon) {
      this.icon.x = (this.game.defaultWidth - this.game.width) / 2 + 360;
      this.icon.y = 40;
    }
  }

  destroy() {
    this.removeChild(this.bg);
    this.removeChild(this.cutscene);
    if (this.cutscene) {
      this.cutscene.destroy();
      this.cutscene = null;
    }

    super.destroy();
  }
}
